import { IconPropsType } from './types/IconsProps.type';

type IconUserInfoProps = & IconPropsType

export const UserInfoIcon = ({
    width = 16,
    height = 17,
    className = '',
    style = {},
    fillColor = 'currentColor',
}: IconUserInfoProps) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 16 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            style={style}
        >
            <path
                d="M9.72411 0.666672C9.39084 0.666672 9.12066 0.936617 9.12066 1.26961C9.12066 1.60261 9.39084 1.87255 9.72411 1.87255C11.0572 1.87255 12.1379 2.95233 12.1379 4.28431C12.1379 5.10336 11.7298 5.82728 11.103 6.26413C10.8297 6.45463 10.7626 6.83047 10.9533 7.10359C11.144 7.37671 11.5201 7.44368 11.7935 7.25317C12.73 6.60047 13.3448 5.51417 13.3448 4.28431C13.3448 2.28634 11.7238 0.666672 9.72411 0.666672Z"
                fill={fillColor}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.27585 1.52801C4.2762 1.52801 2.65517 3.14769 2.65517 5.14565C2.65517 7.14362 4.2762 8.76329 6.27585 8.76329C8.27549 8.76329 9.89652 7.14362 9.89652 5.14565C9.89652 3.14769 8.27549 1.52801 6.27585 1.52801ZM3.86206 5.14565C3.86206 3.81367 4.94275 2.73389 6.27585 2.73389C7.60894 2.73389 8.68963 3.81367 8.68963 5.14565C8.68963 6.47763 7.60894 7.55741 6.27585 7.55741C4.94275 7.55741 3.86206 6.47763 3.86206 5.14565Z"
                fill={fillColor}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.238 10.7263C3.26848 9.89023 4.69302 9.28009 6.27585 9.28009C7.85867 9.28009 9.28321 9.89023 10.3137 10.7263C11.3216 11.5442 12.0517 12.6658 12.0517 13.7512C12.0517 14.8047 11.1291 15.4831 10.1573 15.8713C9.12869 16.2822 7.75397 16.4997 6.27585 16.4997C4.79772 16.4997 3.423 16.2822 2.39439 15.8713C1.42258 15.4831 0.5 14.8047 0.5 13.7512C0.5 12.6658 1.23008 11.5442 2.238 10.7263ZM2.99881 11.6624C2.13469 12.3636 1.70689 13.176 1.70689 13.7512C1.70689 13.9976 1.9422 14.392 2.84242 14.7516C3.68585 15.0885 4.89733 15.2938 6.27585 15.2938C7.65436 15.2938 8.86584 15.0885 9.70927 14.7516C10.6095 14.392 10.8448 13.9976 10.8448 13.7512C10.8448 13.176 10.417 12.3636 9.55288 11.6624C8.71132 10.9796 7.54966 10.486 6.27585 10.486C5.00203 10.486 3.84037 10.9796 2.99881 11.6624Z"
                fill={fillColor}
            />
            <path
                d="M10.6792 8.49333C10.35 8.44202 10.0414 8.66715 9.99002 8.99616C9.93867 9.32518 10.164 9.6335 10.4933 9.68481C11.5894 9.8556 12.5582 10.3753 13.248 11.0156C13.9542 11.6711 14.2931 12.3777 14.2931 12.8903C14.2931 13.0268 14.2333 13.1922 14.022 13.3873C13.8041 13.5884 13.4552 13.789 12.9711 13.9608C12.657 14.0723 12.4929 14.417 12.6044 14.7308C12.716 15.0446 13.061 15.2086 13.3751 15.0971C13.9488 14.8935 14.4615 14.6232 14.841 14.2731C15.2269 13.9168 15.5 13.4507 15.5 12.8903C15.5 11.9129 14.9069 10.9095 14.0695 10.1322C13.2157 9.33968 12.0294 8.70371 10.6792 8.49333Z"
                fill={fillColor}
            />
        </svg>
    );
};

